import { render, staticRenderFns } from "./SLASeguimientoPTI.vue?vue&type=template&id=c6b4da9c&scoped=true"
import script from "./SLASeguimientoPTI.vue?vue&type=script&lang=js"
export * from "./SLASeguimientoPTI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b4da9c",
  null
  
)

export default component.exports